// constants.js
import MapIcon from '@mui/icons-material/Map';
import TerrainIcon from '@mui/icons-material/Terrain';
import SatelliteIcon from '@mui/icons-material/Satellite';

export const VENDORS = ['Palo Alto', 'Cisco', 'Aruba', 'Juniper', 'AireSpring_Velo'];

export const VENDOR_COLORS = {
  'Palo Alto': '#8884d8',
  'Cisco': '#82ca9d',
  'Aruba': '#ffc658',
  'Juniper': '#ff7300',
  'AireSpring_Velo': '#4DAEFF'
};

export const VENDOR_COSTS = {
  'Palo Alto': {
    Small: 10070,
    Medium: 12080,
    Large: 21800,
    DC: 32100,
  },
  'Cisco': {
    Small: 9916,
    Medium: 9916,
    Large: 40898,
    DC: 572812,
  },
  'Aruba': {
    Small: 10598,
    Medium: 26518,
    Large: 40686,
    DC: 107014,
  },
  'Juniper': {
    Small: 15142,
    Medium: 75857,
    Large: 145716,
    DC: 225920,
  },
  'AireSpring_Velo': {
    Small: 7272,
    Medium: 13428,
    Large: 16912,
    DC: 57492
  }
};

export const mapTiles = {
  standard: {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; OpenStreetMap contributors',
    name: 'Standard',
    icon: MapIcon,
  },
  satellite: {
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Imagery &copy; Esri',
    name: 'Satellite',
    icon: SatelliteIcon,
  },
  terrain: {
    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution: '&copy; OpenTopoMap contributors',
    name: 'Terrain',
    icon: TerrainIcon,
  },
};

export const defaultCenter = [20, 0];
export const defaultZoom = 2;

// Site categories
export const SITE_TYPES = ['Small', 'Medium', 'Large', 'DC'];

// Chart colors with 0.7 opacity
export const CHART_COLORS = {
  'Total Cost': 'rgba(230, 244, 255, 0.7)',
  'Small Sites': 'rgba(255, 240, 230, 0.7)',
  'Medium Sites': 'rgba(230, 255, 236, 0.7)',
  'Large Sites': 'rgba(255, 230, 250, 0.7)',
  'DC Sites': 'rgba(240, 255, 230, 0.7)',
};

// Partner types
export const PARTNER_TYPES = {
  CO_MANAGE: 'coManage',
  OUTSOURCE: 'outsource',
  HYBRID: 'hybrid'
};

// Export all constants as a single object as well
export const constants = {
  VENDORS,
  VENDOR_COLORS,
  VENDOR_COSTS,
  mapTiles,
  defaultCenter,
  defaultZoom,
  SITE_TYPES,
  CHART_COLORS,
  PARTNER_TYPES
};

export default constants;